import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import AppliedVisa from "../../components/AppliedVisa";
import { useDispatch } from "react-redux";
import { logOut } from "../../store/User/UserAction";
import { updateProfile } from "../../store/User/UserAction";
import { MdEdit, MdCheck, MdClose } from "react-icons/md";
import { userAction } from "../../store/User/UserReducer";
import { toast } from "react-toastify";
import { visaAppliedAction } from "../../store/VisaApplied/VisaAppliedReducer";
import { getVisaAppliedList } from "../../store/VisaApplied/VisaAppliedAction";
import Loading from "../../components/Loading";


const Dashboard = ({ selectedCurrency }) => {
  const { user, updateUserSuccess, updateUserError, updateUserMessage } = useSelector((state) => state.user);
  const { visaAppliedList, visaAppliedListLoading, visaAppliedListError } = useSelector((state) => state.visaApplied);
  const dispatch = useDispatch();

  const [isEditing, setIsEditing] = useState(false);
  const [email, setEmail] = useState(user.email || "");
  const [tempEmail, setTempEmail] = useState(email);

  useEffect(() => {
    dispatch(getVisaAppliedList({}));
  },[dispatch]);

  useEffect(() => {
    if (visaAppliedListError) {
      dispatch(visaAppliedAction.clearVisaAppliedListError());
      toast.error("Failed to fetch visa applications", {
        position: "top-right",
        bodyStyle: { fontSize: "16px" },
      });
    }
  },[dispatch, visaAppliedListError ]);

  useEffect(() => {
    if (updateUserError) {
      dispatch(userAction.clearUpdateUserError());
      toast.error(updateUserMessage || "Profile Not Updated", {
        position: "top-right",
        bodyStyle: { fontSize: "16px" },
      });
    }

    if (updateUserSuccess) {
      dispatch(userAction.clearUpdateUserSuccess());
      toast.success(updateUserMessage||"Profile Updated", {
        position: "top-right",
        bodyStyle: { fontSize: "16px" },
      });
    }
  }, [
    updateUserError,
    updateUserSuccess,
    updateUserMessage,
    dispatch
  ]);

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleEmailUpdate = () => {
    if (!isValidEmail(tempEmail)) {
      alert("Please enter a valid email address.");
      return;
    }
    
    if (email !== tempEmail) {
      dispatch(updateProfile({ email: tempEmail }));
      setEmail(tempEmail);
    }
    setIsEditing(false);
  };

  const cancelEdit = () => {
    setTempEmail(email); // reset temp value
    setIsEditing(false);
  };

  const handleLogOut = () => {
    dispatch(logOut({}));
  };



  return (
    <div className="dashboard">
      <div className="dashboard__header">
        <div className="dashboard__user-info">
          <div className="dashboard__user-icon">
            <svg className="dashboard__icon" aria-hidden="true" role="img">
              <use href="/sprite.svg#icon-Profile"></use>
            </svg>
            <div className="dashboard__user-mobile">{user.name}</div>
            <div className="dashboard__user-mobile">+ {user.mobile}</div>
            <div className="dashboard__user-email">
            {isEditing ? (
              <div className="dashboard__email-edit-wrapper">
                <input
                  type="email"
                  value={tempEmail}
                  onChange={(e) => setTempEmail(e.target.value)}
                  className="dashboard__email-input"
                />
                <MdCheck className="dashboard__icon-btn" onClick={handleEmailUpdate} title="Save" />
                <MdClose className="dashboard__icon-btn" onClick={cancelEdit} title="Cancel" />
              </div>
            ) : (
              <div className="dashboard__email-display">
                <span>{email}</span>
                <MdEdit className="dashboard__icon-btn" onClick={() => setIsEditing(true)} title="Edit" />
              </div>
            )}
          </div>
          </div>
         

          <button className="dashboard__logout-button" onClick={handleLogOut}>
            LogOut
          </button>
        </div>
      </div>
      <div className="dashboard__content">
        <div className="dashboard__content-heading">Visa Status</div>
        {visaAppliedListLoading ? <Loading></Loading> : <div className="dashboard__visa-list">
          {visaAppliedList.length > 0 ?
            ([...visaAppliedList].reverse().map((visa, index) => (
              <AppliedVisa key={index} visaApplication={visa} />
            ))): <div className="dashboard__no-visa">Looks like you haven't applied for any visas yet.</div>}
        </div>}
      </div>
    </div>
  );
};

export default Dashboard;